import type { TooltipProps } from '@mui/material';

import { Tooltip } from '@mui/material';

function StyledTooltip({ children, ...others }: TooltipProps) {
  return (
    <Tooltip
      disableInteractive
      disableFocusListener
      disableTouchListener
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -11],
              },
            },
          ],
        },
      }}
      {...others}
    >
      {children}
    </Tooltip>
  );
}

export default StyledTooltip;
